export function matchesPattern(url, patterns) {
    const urlObj = new URL(url);
    const hostParts = urlObj.hostname.split('.');
    for (const pattern of patterns) {
        if (pattern.startsWith('*.')) {
            // Match subdomains
            const domainPattern = pattern.slice(2); // remove "*."
            const domainParts = domainPattern.split('.');
            if (hostParts.length < domainParts.length) continue; // continue to the next pattern

            let matches = true;
            for (let i = 0; i < domainParts.length; i++) {
                if (hostParts[hostParts.length - i - 1] !== domainParts[domainParts.length - i - 1]) {
                    matches = false;
                    break;
                }
            }
            if (matches) return true;

        } else {
            // Direct match (with or without path)
            if (url.startsWith(pattern)) {
                return true;
            }
        }
    }

    return false;
}
